import React from "react";
import { InputRangeRow } from "./index";
// Used by the Leesona 861 FC, SSM Kingspool, and Texilmesa Kingspool machines

export default function GrafRow({ minProp, maxProp, errorProp }) {
   return (
      <InputRangeRow
         titleProp={"Graf"}
         descriptionProp={""}
         sizeProp={4}
         colSizeProp={3}
         typeProp={"text"}
         minProp={minProp}
         maxProp={maxProp}
         propertyNameProp={"graf"}
         errorDialogueProp={errorProp || "Cannot be empty"}
         floatProp={true}
      />
   );
}
